"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseClass_1 = __importDefault(require("./BaseClass"));
class Company extends BaseClass_1.default {
    constructor(apiV1, apiV2) {
        super(apiV1, apiV2);
    }
    /**
     * Get list published plan
     * @param clientId - client_id of service
     * @returns
     */
    async getPublishedPlan(clientId) {
        try {
            const data = await this._apiV2.planAPI.getPublishedPlan(clientId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Get plan detail
     * @param planId - id of plan
     * @param clientId - client_id of service
     * @returns
     */
    async getPlanDetail(planId, clientId) {
        try {
            const data = await this._apiV2.planAPI.getPlanDetail(planId, clientId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Get all plan
     * @param planName - name of plan
     * @param page - page number
     * @param limit - limit number
     * @returns
     */
    async getAllPlan(planName, page = 0, limit = 10) {
        try {
            const data = await this._apiV2.planAPI.getAllPlan(planName, page, limit);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Check plan existed or not
     * @param planSlug: slug of plan
     * @returns
     */
    async checkPlanSlugExisted(planSlug) {
        try {
            const data = await this._apiV2.planAPI.checkPlanSlugExisted(planSlug);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Create plan
     * @param name - plan's name
     * @param slug - plan's slug
     * @returns
     */
    async createPlan(name, slug) {
        try {
            const data = await this._apiV2.planAPI.createPlan(name, slug);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * update plan display info
     * @param planId - plan id
     * @param updateParams - info to update plan display
     * @returns
     */
    async updatePlanDisplay(planId, updateParams) {
        try {
            const data = await this._apiV2.planAPI.updatePlanDisplay(planId, updateParams);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * update plan verification info
     * @param planId - plan id
     * @param verifications - array verification info
     * @returns
     */
    async updatePlanVerification(planId, verifications) {
        try {
            const data = await this._apiV2.planAPI.updatePlanVerification(planId, verifications);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * update plan kyc bot info
     * @param planId - plan id
     * @param kycBot - array kyc bot info
     * @returns
     */
    async updatePlanKycBot(planId, kycBot) {
        try {
            const data = await this._apiV2.planAPI.updatePlanKycBot(planId, kycBot);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
}
exports.default = Company;
